import React, {useState} from 'react';
import {
    Button,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
    CircularProgress,
    Box,
    InputLabel,
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
} from '@mui/material';
import {
    fetchDspCompanies,
} from '../../../API/FinancialTools';
import { toast } from 'react-toastify';
import 'react-date-range/dist/styles.css';
import useApi from '../../../hooks/useApi';
import 'react-date-range/dist/theme/default.css';
import {sendDataToApi} from '../../../API/apiHelper';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import KeyboardDoubleArrowDownOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowDownOutlined';
import BackupTableOutlinedIcon from '@mui/icons-material/BackupTableOutlined';
import CreateAdtCompanyDialog from './CreateAdtCompanyDialog';


function AdtCompanyOptionsForm({ onSubmit }) {
    const [loading, setLoading] = useState(false);
    const [openEditBundle, setOpenEditBundle] = useState(false);

    const {data: dspCompany, loading: loadingDspCompany} = useApi(fetchDspCompanies);

    const [editBundle, setEditBundle] = useState({
        company_name: '',
        adt_domain_name: '',
        irtb_id_dsp: '',
        sh_id: '',
        wl_id_web: '',
        wl_id_inapp: '',
        wl_id_ctv: '',
        threshold: '',
        remove_all: false
    });

    const handleSubmit = () => {
        onSubmit();
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setEditBundle(prev => ({
            ...prev,
            [name]: name === 'remove_all' ? value === 'true' : value
        }));
    };

    const handleSaveBundle = () => {
        const userId = localStorage.getItem('user_id');
        const payload = {
            ...editBundle,
            ChangedBy: userId,
        };

        sendDataToApi('post', '/api/adtimizer/company/create', payload, false, (data) => {
            if (data.data.success === true) {
                toast.success('The company has been created!');
                handleSubmit();
                setEditBundle({
                    company_name: '',
                    adt_domain_name: '',
                    irtb_id_dsp: '',
                    sh_id: '',
                    wl_id_web: '',
                    wl_id_inapp: '',
                    wl_id_ctv: '',
                    threshold: '',
                    remove_all: false
                });
                handleCloseEditBundle();
            } else {
                toast.error('The company has not been created!');
                toast.error(data.data.error);
            }
        });
    };

    const handleOpenEditBundle = () => {
        setOpenEditBundle(true);
    };

    const handleCloseEditBundle = () => {
        setOpenEditBundle(false);
    };

    return (
        <Grid container spacing={2} sx={{ width: "100%", marginLeft: '0px' }}>
            <Grid item xs={6} md={6}>
                <Button
                    size="large"
                    startIcon={<BackupTableOutlinedIcon fontSize="small" />}
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                    sx={{ marginLeft: '-15px', marginBottom: '15px' }}
                >
                    Generate Report
                </Button>
                <Button
                    size="large"
                    startIcon={<PlaylistAddIcon fontSize="small" />}
                    onClick={handleOpenEditBundle}
                    variant="contained"
                    color="success"
                    sx={{ marginLeft: '15px', marginBottom: '15px' }}
                >
                    Create
                </Button>
            </Grid>

            {loading && (
                <Grid item xs={12} md={12}>
                    <Box justifyContent="center" textAlign="center" alignItems="center">
                        <CircularProgress size={200} />
                    </Box>
                </Grid>
            )}

            <CreateAdtCompanyDialog
                open={openEditBundle}
                handleClose={handleCloseEditBundle}
                onSuccess={handleSubmit}
                dsp={dspCompany}
            />
        </Grid>
    );
}

export default AdtCompanyOptionsForm;
